module.exports = __webpack_public_path__ + "img/icon-metrika-pro.ede02147.svg";